import React, { useState } from "react";
import LanguageIcon from "@mui/icons-material/Language";
import styles from "./LanguageToggle.module.scss";

const LanguageToggle = ({ lang = "hi", onLanguageChange }) => {
  const [isOn, setIsOn] = useState(lang === "hi");

  const toggle = () => {
    const lang = isOn ? "en" : "hi";

    setIsOn(!isOn);
    onLanguageChange(lang);
  };

  return (
    <div className={styles.toggleContainer}>
      <div
        className={`${styles.toggle} ${isOn ? styles.on : styles.off}`}
        onClick={toggle}
      >
        {isOn && <span className={styles.labelOn}>Hi</span>}
        <LanguageIcon
          className={`${styles.languageIcon} ${isOn && styles.languageIconOn}`}
        />
        {!isOn && <span className={styles.labelOff}>En</span>}
      </div>
    </div>
  );
};

export default LanguageToggle;
